/* Urban Carry slide-out cart (Dave, 19 Oct 2026). Replaces the Rebuy Smart Cart; see snippets/uc-cart.liquid. */
(function () {
  'use strict';
  var root = document.getElementById('uc-cart');
  var dataEl = document.getElementById('uc-cart-data');
  if (!root || !dataEl) return;
  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { console.log('uc-cart data', e); return; }
  var P = D.products || {};
  var OP_ID = P.protection && P.protection.variants[0] ? P.protection.variants[0].id : null;
  var cart = null, opAuto = false, busy = false, lastFocus = null, upPick = {};

  function q(s) { return root.querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function track(name, params) { try { if (window.gtag) window.gtag('event', name, params || {}); } catch (e) { console.log('uc-cart gtag', e); } }

  // ---- what is in the cart ------------------------------------------------------------------
  function opt(item, name) {
    var o = (item.options_with_values || []).filter(function (x) { return String(x.name).toLowerCase() === name; })[0];
    return o ? o.value : '';
  }
  function hay(i) { return (i.handle + ' ' + i.product_title).toLowerCase(); }
  function isProtection(i) { return i.variant_id === OP_ID || /shipping-insurance/.test(i.handle); }
  function isMag(i) { return /magazine|mag holster|extra mag|dual mag/.test(hay(i)); }
  function isBelt(i) { return String(i.product_type).toLowerCase() === 'belts' || /gun-belt|-belts?$/.test(i.handle); }
  function isCond(i) { return /conditioner/.test(hay(i)); }
  function isHolster(i) { return String(i.product_type).toLowerCase() === 'weapons holsters' && !isMag(i) && !/shoulder/.test(hay(i)); }
  // "Signature OWB Holster & Extra Mag" already carries a mag holster
  function bundlesMag(i) { return /extra-mag|extra mag/.test(hay(i)); }

  function profile(c) {
    var items = (c.items || []).filter(function (i) { return !isProtection(i); });
    var hol = items.filter(isHolster).sort(function (a, b) { return b.final_price - a.final_price; });
    var h = hol[0] || null, fam = '', carry = '';
    if (h) {
      var s = hay(h);
      fam = /(^|\W)g3(\W|$)|urban-carry-g3/.test(s) ? 'g3' : /mavado/.test(s) ? 'mavado' : /hyperion/.test(s) ? 'hyperion' : 'signature';
      carry = fam === 'g3' ? 'g3' : /owb/.test(s) ? 'owb' : 'iwb';
    }
    return {
      items: items, holster: h, family: fam, carry: carry,
      color: h ? opt(h, 'color') : '', clip: h ? opt(h, 'belt clip size') : '',
      hasBelt: items.some(isBelt), hasMag: items.some(function (i) { return isMag(i) || bundlesMag(i); }), hasCond: items.some(isCond)
    };
  }

  // ---- matching leather ---------------------------------------------------------------------
  function optIndex(p, name) { var n = (p.options || []).map(function (x) { return String(x).toLowerCase(); }); return n.indexOf(name); }
  function colorsOf(p) { var ci = optIndex(p, 'color'), out = []; if (ci < 0) return out; p.variants.forEach(function (v) { if (out.indexOf(v.o[ci]) < 0) out.push(v.o[ci]); }); return out; }
  // Same rule as the showroom's belt add-on: the same name, else black with black, else the first brown
  function matchColor(p, want) {
    var cols = colorsOf(p); if (!cols.length) return '';
    if (cols.indexOf(want) > -1) return want;
    var blk = /black/i.test(want || '');
    return cols.filter(function (c) { return /black/i.test(c) === blk && (blk || /brown/i.test(c)); })[0] || cols[0];
  }

  // ---- the upsell, in Dave's priority order (first match wins) --------------------------------
  var RULES = [
    { key: 'belt', when: function (f) { return f.holster && !f.hasBelt; },
      offer: function (f) { return { k: f.family === 'mavado' ? 'belt_mavado' : 'belt_hd', why: 'Matches your holster leather', pick: ['size'] }; } },
    { key: 'mag', when: function (f) { return f.holster && f.hasBelt && !f.hasMag; },
      offer: function (f) {
        if (f.carry === 'g3') return { k: 'mag_g3', why: 'Clips on next to your G3', pick: ['magazine capacity'] };
        if (f.carry === 'owb') return { k: 'mag_owb', why: 'Carry a spare beside your holster', pick: ['magazine capacity'] };
        // No Mavado mag holster exists: Mavado gets the Signature LockLeather IWB mag (Dave, 19 Oct 2026)
        return { k: 'mag_iwb', why: f.family === 'mavado' ? 'Signature LockLeather mag holster, pairs with your Mavado' : 'Carry a spare beside your holster', pick: [] };
      } },
    { key: 'conditioner', when: function (f) { return f.items.length && !f.hasCond; },
      offer: function () { return { k: 'conditioner', why: 'Keeps the leather supple. Use every 6 to 12 months', pick: [] }; } }
  ];

  function chooseOffer(f) {
    for (var r = 0; r < RULES.length; r++) {
      if (!RULES[r].when(f)) continue;
      var o = RULES[r].offer(f), p = P[o.k];
      if (!p || !p.variants.some(function (v) { return v.available; })) continue;
      o.rule = RULES[r].key; o.p = p; return o;
    }
    return null;
  }

  // Fixed parts of the variant: colour (matched), G3 clip size (matched); the rest the shopper picks
  function fixedFor(o, f) {
    var fx = {}, p = o.p, ci = optIndex(p, 'color'), si = optIndex(p, 'size');
    if (ci > -1) fx[ci] = matchColor(p, f.color);
    if (o.k === 'mag_g3' && si > -1 && f.clip) fx[si] = f.clip;
    return fx;
  }
  function candidates(o, f) {
    var fx = fixedFor(o, f);
    return o.p.variants.filter(function (v) { return v.available && Object.keys(fx).every(function (i) { return v.o[i] === fx[i]; }); });
  }
  function resolve(o, f) {
    var c = candidates(o, f), pk = upPick[o.k] || {};
    var free = o.pick.map(function (n) { return optIndex(o.p, n); }).filter(function (i) { return i > -1; });
    var hit = c.filter(function (v) { return free.every(function (i) { return pk[i] ? v.o[i] === pk[i] : true; }); });
    var needs = free.filter(function (i) { return !pk[i] && o.k.indexOf('belt') === 0; }); // a waist size is never assumed
    return { list: c, free: free, variant: needs.length ? null : (hit[0] || null), needs: needs };
  }

  // Dave, 19 Oct 2026: "Pick size" is the button. It opens the phone's own size list, and choosing a size adds the belt
  function beltPicker(list, p) {
    var si = optIndex(p, 'size');
    var opts = list.map(function (v) {
      var m = /(\d+)\s*Belt\s*\((\d+)/i.exec(v.o[si] || '');
      var lab = m ? 'Pants ' + m[2] + '"  =  ' + m[1] + '" belt' : v.o[si];
      return '<option value="' + v.id + '">' + esc(lab) + '</option>';
    }).join('');
    return '<span class="ucc__pick"><span class="ucc__add" aria-hidden="true">Pick size</span>' +
      '<select data-ucc-belt aria-label="Pick your pant waist size to add the belt"><option value="" selected disabled>Your pant waist size</option>' + opts + '</select></span>';
  }
  function renderUp(f) {
    var box = q('[data-ucc-up]'), o = chooseOffer(f);
    if (!o) { box.hidden = true; box.innerHTML = ''; return; }
    var r = resolve(o, f), v = r.variant || r.list[0];
    if (!v) { box.hidden = true; box.innerHTML = ''; return; }
    var color = (function () { var ci = optIndex(o.p, 'color'); return ci > -1 ? (r.list[0] || {}).o[ci] : ''; })();
    var title = o.p.title.replace(/s$/, '').replace(/^8oz - /, '') + (color ? ', ' + color : '');
    var isBeltOffer = o.k.indexOf('belt') === 0;
    var sels = r.free.map(function (i) {
      var name = o.p.options[i], vals = [];
      r.list.forEach(function (x) { if (vals.indexOf(x.o[i]) < 0) vals.push(x.o[i]); });
      if (vals.length < 2 || isBeltOffer) return '';
      var cur = (upPick[o.k] || {})[i] || '';
      var lab = /size/i.test(name) ? 'Waist size' : /capacity/i.test(name) ? 'Magazines' : name;
      return '<label class="ucc__sel"><span>' + esc(lab) + '</span><select data-ucc-opt="' + i + '">' +
        (o.k.indexOf('belt') === 0 ? '<option value=""' + (cur ? '' : ' selected') + '>Choose your size</option>' : '') +
        vals.map(function (x) { return '<option' + (x === cur ? ' selected' : '') + '>' + esc(x) + '</option>'; }).join('') + '</select></label>';
    }).join('');
    box.hidden = false;
    box.setAttribute('data-k', o.k); box.setAttribute('data-rule', o.rule);
    box.innerHTML = '<p class="ucc__up-hd">Complete your setup</p><div class="ucc__up-card">' +
      '<img src="' + esc((v.img || o.p.img || '').replace(/^\/\//, 'https://')) + '" alt="" width="64" height="64" loading="lazy">' +
      '<div class="ucc__up-tx"><b>' + esc(title) + '</b><small>' + esc(o.why) + '</small><span class="ucc__up-p">' + money(v.price) + '</span></div>' +
      (isBeltOffer ? beltPicker(r.list, o.p) : '<button type="button" class="ucc__add" data-ucc-add>Add</button>') + '</div>' +
      (sels ? '<div class="ucc__sels">' + sels + '</div>' : '');
    box._offer = o; box._fam = f;
    if (box.getAttribute('data-shown') !== o.k) { box.setAttribute('data-shown', o.k); track('cart_upsell_view', { offer: o.k, rule: o.rule }); }
  }

  // ---- cart lines ---------------------------------------------------------------------------
  function thumb(i) {
    var own = i.properties && i.properties._img;
    if (own) return own;
    return i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
  }
  function propsHtml(i) {
    var p = i.properties || {}, out = [];
    Object.keys(p).forEach(function (k) { if (k.charAt(0) !== '_' && p[k] !== '' && p[k] != null) out.push('<li>' + esc(k) + ': ' + esc(p[k]) + '</li>'); });
    return out.length ? '<ul class="ucc__props">' + out.join('') + '</ul>' : '';
  }
  // A shoulder rig built in the builder shows as one set with its pieces under it (Dave, 20 Oct 2026); the lines are
  // still separate products in the cart, so stock and fulfilment are unchanged
  // Build order: holster, rig, mags or second piece, anchors
  function partRank(i) {
    var t = String((i.properties && i.properties._rig_part) || i.product_title).toLowerCase();
    return /anchor/.test(t) ? 3 : /^shoulder rig|rig,/.test(t) ? 1 : /holster/.test(t) && !/mag/.test(t) && t.indexOf('second') < 0 ? 0 : 2;
  }
  function rigHtml(id, lines) {
    var p = lines[0].properties || {}, qty = Math.min.apply(null, lines.map(function (i) { return i.quantity; }));
    var total = lines.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    return '<li class="ucc__it ucc__it--rig" data-rig="' + esc(id) + '">' +
      '<span class="ucc__img">' + (p._rig_img ? '<img src="' + esc(p._rig_img) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</span>' +
      '<div class="ucc__it-tx"><span class="ucc__nm">' + esc(p._rig_title || 'Shoulder Rig Setup') + '</span>' + (p._rig_sub ? '<span class="ucc__vt">' + esc(p._rig_sub) + '</span>' : '') +
      '<ul class="ucc__parts">' + lines.slice().sort(function (a, b) { return partRank(a) - partRank(b); }).map(function (i) { return '<li><span>' + esc(i.properties._rig_part || i.product_title) + '</span><span>' + money(i.final_line_price / Math.max(1, i.quantity)) + '</span></li>'; }).join('') + '</ul>' +
      '<div class="ucc__row"><div class="ucc__qty"><button type="button" data-ucc-q="-1" aria-label="One fewer set">&minus;</button><span>' + qty + '</span><button type="button" data-ucc-q="1" aria-label="One more set">+</button></div>' +
      '<button type="button" class="ucc__rm" data-ucc-rm>Remove</button><span class="ucc__lp">' + money(total) + '</span></div></div></li>';
  }
  function renderItems(f) {
    var rigs = {}, done = {};
    f.items.forEach(function (i) { var r = i.properties && i.properties._rig; if (r) (rigs[r] = rigs[r] || []).push(i); });
    q('[data-ucc-items]').innerHTML = f.items.map(function (i) {
      var r = i.properties && i.properties._rig;
      if (r) { if (done[r]) return ''; done[r] = 1; return rigHtml(r, rigs[r]); }
      var vt = i.variant_title && i.variant_title !== 'Default Title' ? '<span class="ucc__vt">' + esc(i.variant_title) + '</span>' : '';
      var was = i.original_line_price > i.final_line_price ? '<s>' + money(i.original_line_price) + '</s> ' : '';
      return '<li class="ucc__it" data-key="' + esc(i.key) + '">' +
        '<a href="' + esc(i.url) + '" class="ucc__img">' + (thumb(i) ? '<img src="' + esc(thumb(i)) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
        '<div class="ucc__it-tx"><a href="' + esc(i.url) + '" class="ucc__nm">' + esc(i.product_title) + '</a>' + vt + propsHtml(i) +
        '<div class="ucc__row"><div class="ucc__qty"><button type="button" data-ucc-q="-1" aria-label="One fewer">&minus;</button><span>' + i.quantity + '</span><button type="button" data-ucc-q="1" aria-label="One more">+</button></div>' +
        '<button type="button" class="ucc__rm" data-ucc-rm>Remove</button><span class="ucc__lp">' + was + money(i.final_line_price) + '</span></div></div></li>';
    }).join('');
  }
  function render() {
    if (!cart) return;
    var f = profile(cart), n = f.items.reduce(function (s, i) { return s + i.quantity; }, 0);
    var op = (cart.items || []).filter(isProtection)[0];
    var goods = f.items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    q('[data-ucc-count]').textContent = n ? '(' + n + ')' : '';
    q('[data-ucc-empty]').hidden = !!n;
    q('[data-ucc-ft]').hidden = !n;
    renderItems(f);
    var left = D.freeShip - goods, pct = Math.max(0, Math.min(100, Math.round(goods / D.freeShip * 100)));
    var ship = q('[data-ucc-ship]');
    ship.hidden = !n;
    ship.className = 'ucc__ship' + (left <= 0 ? ' is-got' : '');
    ship.innerHTML = (left > 0 ? 'You are <b>' + money(left) + '</b> away from free shipping.' : '<b>Free shipping unlocked.</b>') + '<span class="ucc__bar"><i style="width:' + pct + '%"></i></span>';
    var opl = q('[data-ucc-op]');
    if (OP_ID && n) { opl.hidden = false; q('[data-ucc-op-box]').checked = !!op; q('[data-ucc-op-p]').textContent = money(P.protection.variants[0].price); } else opl.hidden = true;
    q('[data-ucc-sub]').textContent = money(cart.total_price);
    renderUp(f);
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', n > 0); });
  }

  // ---- talking to Shopify -------------------------------------------------------------------
  function api(url, body) {
    return fetchRaw(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.text().then(function (t) {
          var j = null; try { j = JSON.parse(t); } catch (e) { console.log('uc-cart non-JSON', r.status); }
          if (!j) throw new Error(r.status === 429 ? 'The cart is busy. Please try again in a moment.' : 'Could not reach the cart. Please try again.');
          if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong');
          return j;
        });
      });
  }
  function err(m) { var e = q('[data-ucc-err]'); e.textContent = m || ''; e.hidden = !m; }
  function refresh() { return api('/cart.js').then(function (c) { cart = c; tidy(); render(); return c; }); }
  // Order Protection alone in a cart is not an order
  function tidy() {
    // A gift card ships nothing, so it never brings Order Protection in on its own (Dave, 20 Oct 2026)
    var real = (cart.items || []).filter(function (i) { return !isProtection(i) && !i.gift_card; });
    var op = (cart.items || []).filter(isProtection)[0];
    if (op && !real.length) return change(op.key, 0);
    // On by default (Dave, 19 Oct 2026); unticking is remembered on the cart as _uc_op_off and never undone
    var off = cart.attributes && cart.attributes._uc_op_off;
    // Removed on the cart page (not through the switch): this cart had it and lost it, so treat that as unticked
    var seen = ''; try { seen = localStorage.getItem('ucOpSeen') || ''; } catch (e) { console.log('uc-cart storage', e); }
    if (op) { try { localStorage.setItem('ucOpSeen', cart.token); } catch (e) { console.log('uc-cart storage', e); } }
    else if (!off && seen && seen === cart.token) { off = '1'; api('/cart/update.js', { attributes: { _uc_op_off: '1' } }).catch(function (e) { console.log('uc-cart op attribute', e); }); }
    if (OP_ID && real.length && !op && !off && !opAuto) {
      opAuto = true;
      api('/cart/add.js', { items: [{ id: OP_ID, quantity: 1 }] }).then(function (x) { console.log('uc-cart protection on by default', x && x.items && x.items.length); return refresh(); })
        .catch(function (e) { console.log('uc-cart protection default', e); }).then(function () { opAuto = false; });
    }
  }
  function change(key, qty) {
    if (busy) return Promise.resolve(); busy = true; root.classList.add('is-busy'); err('');
    return api('/cart/change.js', { id: key, quantity: qty }).then(function (c) { cart = c; tidy(); render(); })
      .catch(function (e) { err(e.message); }).then(function () { busy = false; root.classList.remove('is-busy'); });
  }
  function changeMany(updates) {
    if (busy) return Promise.resolve(); busy = true; root.classList.add('is-busy'); err('');
    return api('/cart/update.js', { updates: updates }).then(function (c) { cart = c; tidy(); render(); })
      .catch(function (e) { err(e.message); }).then(function () { busy = false; root.classList.remove('is-busy'); });
  }
  function rigLines(id) { return cart.items.filter(function (i) { return i.properties && i.properties._rig === id; }); }
  function add(items) {
    busy = true; root.classList.add('is-busy'); err('');
    return api('/cart/add.js', { items: items }).then(refresh).catch(function (e) { err(e.message); })
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  // ---- open / close -------------------------------------------------------------------------
  function open() {
    if (root.classList.contains('is-open')) return refresh();
    lastFocus = document.activeElement; root.hidden = false; root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ucc-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); q('.ucc__panel').focus(); });
    track('cart_drawer_open');
    return refresh().catch(function (e) { err(e.message); });
  }
  function close() {
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ucc-lock');
    setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-ucc-close]')) return close();
    var rig = t.closest('[data-rig]');
    if (rig && (t.closest('[data-ucc-rm]') || t.closest('[data-ucc-q]'))) {
      var ls = rigLines(rig.getAttribute('data-rig')), base = Math.min.apply(null, ls.map(function (i) { return i.quantity; })) || 1;
      var to = t.closest('[data-ucc-rm]') ? 0 : Math.max(0, base + Number(t.closest('[data-ucc-q]').getAttribute('data-ucc-q'))), up = {};
      ls.forEach(function (i) { up[i.key] = Math.round(i.quantity / base * to); });
      return changeMany(up);
    }
    var li = t.closest('.ucc__it');
    if (li && t.closest('[data-ucc-rm]')) return change(li.getAttribute('data-key'), 0);
    var qb = t.closest('[data-ucc-q]');
    if (li && qb) { var it = cart.items.filter(function (i) { return i.key === li.getAttribute('data-key'); })[0]; if (it) change(it.key, Math.max(0, it.quantity + Number(qb.getAttribute('data-ucc-q')))); return; }
    if (t.closest('[data-ucc-add]')) {
      var box = q('[data-ucc-up]'), o = box._offer, r = o && resolve(o, box._fam);
      if (!r || !r.variant) return;
      track('cart_upsell_add', { offer: o.k, rule: o.rule, value: r.variant.price / 100 });
      add([{ id: r.variant.id, quantity: 1, properties: { _upsell: o.rule } }]);
    }
    if (t.closest('[data-ucc-go]')) track('cart_drawer_checkout', { value: cart ? cart.total_price / 100 : 0 });
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-ucc-op-box]')) {
      var op = (cart.items || []).filter(isProtection)[0];
      track('cart_protection_toggle', { on: t.checked });
      var note = api('/cart/update.js', { attributes: { _uc_op_off: t.checked ? '' : '1' } }).catch(function (e) { console.log('uc-cart op attribute', e); });
      note.then(function () { if (t.checked && !op) add([{ id: OP_ID, quantity: 1 }]); else if (!t.checked && op) change(op.key, 0); });
      return;
    }
    if (t.matches('[data-ucc-belt]')) {
      var bx = q('[data-ucc-up]'), bo = bx._offer, vid = Number(t.value);
      var bv = bo && bo.p.variants.filter(function (v) { return v.id === vid; })[0];
      if (!bv) return;
      track('cart_upsell_add', { offer: bo.k, rule: bo.rule, value: bv.price / 100 });
      add([{ id: bv.id, quantity: 1, properties: { _upsell: bo.rule } }]);
      return;
    }
    if (t.matches('[data-ucc-opt]')) {
      var box = q('[data-ucc-up]'), k = box.getAttribute('data-k');
      upPick[k] = upPick[k] || {}; upPick[k][t.getAttribute('data-ucc-opt')] = t.value;
      renderUp(box._fam);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  // The header cart icon opens the drawer (the cart page itself stays a page)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="/cart"], a[href$="/cart"], .js-drawer-open-cart');
    if (!a || root.contains(a) || /\/cart\/?$/.test(location.pathname) || e.metaKey || e.ctrlKey) return;
    e.preventDefault(); open();
  }, true);

  // Anything on the site that adds to the cart opens the drawer: fetch, XHR and plain product forms
  var fetchRaw = window.fetch.bind(window);
  // Order Protection goes into the cart just BEFORE the first item, so it is the oldest line and sits at the
  // bottom of the checkout list (Dave, 19 Oct 2026). Shopify lists the newest line first.
  function needsOpFirst() {
    return !!(OP_ID && cart && !(cart.items || []).some(isProtection) && !(cart.attributes && cart.attributes._uc_op_off) &&
      !(cart.items || []).length);
  }
  function opFirst() {
    if (!needsOpFirst()) return Promise.resolve();
    cart.items = [{ variant_id: OP_ID, handle: 'shipping-insurance' }];
    return fetchRaw('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: OP_ID, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) console.log('uc-cart protection first', r.status); })
      .catch(function (e) { console.log('uc-cart protection first', e); });
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var gift = !!(init && init.headers && (init.headers['X-UC-Gift'] || (init.headers.get && init.headers.get('X-UC-Gift'))));
    var p = isAdd && !gift && needsOpFirst() ? opFirst().then(function () { return fetchRaw(input, init); }) : fetchRaw(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) p.then(function (r) { if (r.ok) setTimeout(open, 50); });
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (/\/cart\/add(\.js)?(\?|$)/.test(String(url))) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) setTimeout(open, 50); });
    return xo.apply(this, arguments);
  };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || !/\/cart\/add(\?|$)/.test(f.getAttribute('action') || '') || e.defaultPrevented) return;
    e.preventDefault();
    var fd = new FormData(f);
    opFirst().then(function () { return fetchRaw('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd }); })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message); return j; }); })
      .then(function () { open(); })
      .catch(function (x) { console.log('uc-cart form add', x); f.submit(); });
  });

  // Rebuy's script is added store-wide by the Rebuy app, not by the theme, so it can still load here.
  // While both exist, its side cart must never open over ours.
  ['rebuy:smartcart.show', 'rebuy:smartcart.ready'].forEach(function (ev) {
    document.addEventListener(ev, function () { try { if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.hide) Rebuy.SmartCart.hide(); } catch (e) { console.log('uc-cart rebuy hide', e); } });
  });

  api('/cart.js').then(function (c) { if (!cart) cart = c; }).catch(function (e) { console.log('uc-cart first read', e); });

  window.UCCart = { open: open, close: close, refresh: refresh, rules: RULES, profile: profile, chooseOffer: chooseOffer };
  document.dispatchEvent(new CustomEvent('uccart:ready'));
})();
